// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3b18fcce","732":"26adc3c1","977":"4956c5c1"}[chunkId] + ".chunk.js";
};